export const FRONTEND_APP_TYPE = 'frontend'
export const BACKEND_APP_TYPE = 'backend'
